import { getFontSize } from '../../constants/fontSizes';

export const privacyPolicyStyles = {
  container: {
    backgroundColor: 'secondary.main',
    minHeight: '100vh',
    width: '100%',
  },
  headerContainer: {
    padding: { xs: "20px", lg: "35px 75px" },
    position: 'relative',
    zIndex: 2,
  },
  contentContainer: {
    padding: { xs: "20px", lg: "0 75px 75px 75px" },
  },
  title: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(82),
    lineHeight: { xs: '36px', lg: '56px' },
    letterSpacing: '-1%',
    color: 'primary.main',
    marginBottom: { xs: '30px', lg: '100px' },
    marginTop: { xs: '30px', lg: '50px' },
  },
  section: {
    position: 'relative',
    marginBottom: '40px' ,
    paddingBottom: '20px' ,
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '50%',
      borderBottom: '1px solid #E3E3E3',
    },
  },
  sectionLast: {
    position: 'relative',
    marginBottom: '40px',
    paddingBottom: '20px',
  },
  heading: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(30),
    lineHeight: '30px',
    letterSpacing: '-1%',
    color: '#1f1f1f',
    marginBottom: { xs: '15px', lg: '20px' },
  },
  numberedHeading: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(30),
    lineHeight: '30px',
    letterSpacing: '-1%',
    color: '#1f1f1f',
    marginBottom: { xs: '15px', lg: '20px' },
  },
  subheading: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(30),
    lineHeight: '30px',
    letterSpacing: '-1%',
    color: '#1f1f1f',
    marginTop: { xs: '20px', lg: '25px' },
    marginBottom: { xs: '10px', lg: '15px' },
  },
  subheading2: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(20),
    lineHeight: '28px',
    letterSpacing: '-1%',
    color: '#5A6074',

  },
  text: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: '28px',
    letterSpacing: '-1%',
    color: '#5A6074',
    marginBottom: { xs: '15px', lg: '20px' },
  },
  boldText: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: getFontSize(20),
    lineHeight: '28px',
    letterSpacing: '-1%',
    color: '#5A6074',
    marginBottom: { xs: '15px', lg: '20px' },
  },
  list: {
    listStyle: 'none',
    marginLeft: { xs: '20px', lg: '30px' },
    marginTop: { xs: '10px', lg: '15px' },
    marginBottom: { xs: '15px', lg: '20px' },
    paddingLeft: 0,
    '& li': {
      position: 'relative',
      paddingLeft: { xs: '20px', lg: '24px' },
      '&::before': {
        content: '"\\2022"',
        position: 'absolute',
        left: 0,
        top: 0,
        fontFamily: 'Lato',
        fontSize: getFontSize(18),
        lineHeight: '28px',
        color: '#5A6074',
      },
    },
  },
  listItem: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(18),
    lineHeight: '28px',
    letterSpacing: '-1%',
    color: '#5A6074',
  },
  subsection: {
    marginTop: { xs: '20px', lg: '25px' },
  },
  link: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: '28px',
    letterSpacing: '-1%',
    textDecoration: 'underline',
    color: '#5A6074',
  },
};

